export function validateMfeInitConfig(config) {
    const element = config.element;
    delete config.element;
    try {
        return Object.assign({ element: element }, JSON.parse(JSON.stringify(config)));
    }
    catch (e) {
        console.error('The config object is not valid. It could not be serialized and then deserialized. Please fix.');
        return config;
    }
}
